import { Injectable } from '@angular/core';
import {User} from '../model/user';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {config} from '../../shared/config';
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { ResetPassword } from '../model/reset-password';
import { ResetPasswordResponse } from '../model/reset-password-response';
import { ForgotPasswordResponse } from '../model/forgot-password-response';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';
import { PasswordPolicy } from '../../shared/models/password-policy.model';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }


  login(username: string, password: string, language: string) {
    return this._http.post<any>(config.apiUrl + 'api/Auth/login', {login: username, password: password}, {withCredentials: true, headers: new HttpHeaders({'accept-language': language})})
      .pipe(map(user => {
        let prepareUser: User;
        if (user && user.data && user.data.accessToken) {
          const decodedToken = jwt_decode(user.data.accessToken);
          const clientId = Number(JSON.parse(decodedToken['clientId']))
          const clientName =  decodedToken['clientName'];

          prepareUser = <User>{username: username, accessToken: user.data.accessToken, language: language, clientId, clientName };
        }
        return prepareUser;
      }));
  }

  logout() {
    return this.get(config.apiUrl + 'api/Auth/logout');
  }

  forgotPassword(data): Observable<ForgotPasswordResponse> {
    return this._http.post(config.apiUrl + 'api/Auth/forgotpassword', data)
      .pipe(
        map(res => <ForgotPasswordResponse>res[data])
      );
  }

  resetPassword(data: ResetPassword): Observable<ResetPasswordResponse> {
    return this._http.post(config.generateApiUrl('Auth/resetpassword'), data).pipe(
      map((resp) => resp['data'])
    );
  }

  getDefaultPasswordPolicy(): Observable<PasswordPolicy> {
    return this.get(config.generateApiUrl('Auth/resetpassword/defaultpasswordpolicy')).pipe(
      map((resp) => JSON.parse(resp['data']) as PasswordPolicy)
    );
  }
}
